import { render, staticRenderFns } from "./DistressalertsModals.vue?vue&type=template&id=5fc22b1a"
import script from "./DistressalertsModals.vue?vue&type=script&lang=js"
export * from "./DistressalertsModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports